import type { PatchTenantRequestPayload } from "../../tenants.api";

/**
 * patchTenantAfterDescriptionStep saves the description and moves the
 * onboarding on: to services while the branding step is still ahead, else
 * to done.
 */
export function patchTenantAfterDescriptionStep(args: {
  description: string;
  branding_step_enabled: boolean;
  current_company_onboarding?: string;
}): PatchTenantRequestPayload {
  const next = args.branding_step_enabled ? "services" : "done";
  return {
    description: args.description,
    // onboarding never goes back, so a finished setup stays done
    company_onboarding:
      args.current_company_onboarding === "done" ? "done" : next,
  };
}
